import { Breadcrumb as PrimitiveBreadcrumb } from '@repo/ui';
import { useNavigate } from 'react-router-dom';
import breadcrumbResultsPortalParser from 'utils/breadcrumb/parser/breadcrumbResultsPortalParser';
import { SCROLL_RETURN_STATE } from 'utils/scroll/scrollIntent';

type Props = {
  overrides?: Record<string, string | undefined>;
  className?: string;
  gutBodyConnections?: boolean;
};

export default function Breadcrumb({
  overrides,
  className,
  gutBodyConnections,
}: Props) {
  const navigate = useNavigate();

  return (
    <PrimitiveBreadcrumb
      parser={args =>
        breadcrumbResultsPortalParser({ ...args, gutBodyConnections })
      }
      onNavigate={href => navigate(href, { state: SCROLL_RETURN_STATE })}
      overrides={overrides}
      className={className}
    />
  );
}
